/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx.Fragment
 */
import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { LazyAnimatedRovoIcon } from '@atlassian/conversation-assistant-ui-components/ui/LazyAnimatedRovoIcon';

import { MainWrapper } from '../main-wrapper';

const styles = cssMap({
	miniModalMainContainer: {
		width: '400px',
		borderRadius: token('radius.small'),
		backgroundColor: token('elevation.surface.raised'),
		boxShadow: token('elevation.shadow.overlay'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	rovoIcon: {
		width: '48px',
		height: '48px',
	},
});

export const MiniModalLoadingFallbackComponent = ({
	topOffset,
	isNav4Enabled,
}: {
	topOffset: number;
	isNav4Enabled: boolean;
}): JSX.Element => {
	return (
		<MainWrapper mode="mini-modal" isNav4Enabled={isNav4Enabled}>
			<Box
				testId="conversation-assistant-mini-modal-main-container"
				xcss={styles.miniModalMainContainer}
				style={{
					height: `min(320px, calc(100vh - ${topOffset}px))`,
				}}
			>
				<Box xcss={styles.rovoIcon}>
					<LazyAnimatedRovoIcon alt="" testId="rovo-loading-animation" />
				</Box>
			</Box>
		</MainWrapper>
	);
};
